module.exports = __webpack_public_path__ + "static/media/image-card-1.0cb43588.png";